import { LoaderFunction, redirect } from 'react-router-dom'

import { proposedAppointmentPath } from '@/router/paths.ts'
import { useAppointmentStore } from '@/store.ts'

interface LoaderData {
  error?: string
}

const loader: LoaderFunction<LoaderData> = async ({ params }) => {
  const { appointmentType, category, doctorId, locationId } = params as {
    appointmentType: string
    category: string
    doctorId: string
    locationId: string
  }
  const selectedLocation = useAppointmentStore.getState().selectedLocation

  // if entered screen by URL, no location is selected
  if (!selectedLocation) {
    return redirect(
      proposedAppointmentPath({
        appointmentType,
        category,
        doctorId,
        locationId,
      }),
    )
  }
  return null
}

export type { LoaderData }
export { loader }
